

import { useParams } from "react-router-dom";
import { LayoutOps } from "../../layouts";
import { useListReporteXOps } from "../../../hooks/cache";
import { CargandoMedio } from "../../components";
import { TablaReporteInventario, TablaReporteInventarioTotales } from "../../caja/components";







export const InventarioOp = () => {


    const { id } = useParams();
    const { data, isLoading, chagePage, page } = useListReporteXOps(id);  


    return (
        <LayoutOps titulo={'Información inventario de O.P.'}>
            {(isLoading) 
            ?   <CargandoMedio titulo="Cargando información de inventario en op." />

            :   <>
                <TablaReporteInventarioTotales datos={data || []} />
                <TablaReporteInventario data={data || []} chagePage={chagePage} page={page} view /> 
                </>
            }
        </LayoutOps>
    )
}
